$( document ).ready(function() {
  $('.slick-carousel').slick({
    arrows: true,
    centerPadding: "20px",
    dots: false,
    slidesToShow: 2,
    infinite: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });
    
});

